import { useEffect } from 'react';
import { sendAdobeAnalyticsRegistration } from 'ciam-self-service-shared';

const useAdobeAnalyticsRegistration = (error, isVerified) => {
  useEffect(() => {
    sendAdobeAnalyticsRegistration('START');
  }, []);

  useEffect(() => {
    if (error?.errorCode) {
      sendAdobeAnalyticsRegistration('ERROR', {
        error: {
          errorCode: error?.errorCode,
          errorType: error?.errorType,
          errorDescription: error?.description,
          errorCategory: error?.errorCategory,
        },
      });
    }
  }, [error]);

  useEffect(() => {
    if (isVerified) {
      sendAdobeAnalyticsRegistration('COMPLETE');
    }
  }, [isVerified]);
};

export default useAdobeAnalyticsRegistration;
